import React from "react";
import Card from "../../common/Card";
import { User } from "@phosphor-icons/react";

const References = () => {
    return <Card title={"المراجع"} icon={<User size={32} />}></Card>;
};

export default References;
